import React, { Component } from "react";
import DatePicker from "react-datepicker";
import ReactTable from "react-table";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import request from "../../../lib/requester";
import _, { toNumber } from "lodash";
import moment from "moment";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import Autocomplete from "../../../component/autocomplete";
import axios from "axios";
import requester from "../../../lib/requester";

class SendDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sDest: "CAB",
      sCustomerId: "",
      sCustomerName: "",
      sCabangId: "",
      sCabangName: "",
      sScanResult: "",
      sScan: "",
      sAwbNumber: "",
      sAwbDate: "",
      sDocNumber: "",
      sDocDate: new Date(),
      lovCabang: [],
      user: JSON.parse(window.localStorage.getItem("is_user")),
      branchCollection: "",
      error: [],
      success: "",
      errorscan: 0,
      dataTable: [],
      loading: false,
      sDocType: "",
      sDatainsert: [],
      filePATH: "",
      submitted_stat: false,
      sRO: "N",
      sPopular_name: "",
      docs: [],
      supportComplete: "COMPLETE",
      exist: "N",
      dataInvoice: {},
      dataSupport: {},
      ableSubmit: false,
      documentList: [],
      supStatus: "N",
      supStatusStr: "NOT COMPLETE",
      newScan : ""
    };
  }

  componentDidMount = () => {
    // this.getBranch();
    let username = this.state.user.role_name;
    // alert (username)

    if (username == 'ADM-INKASO') 
    {
      this.setState({ sDocType: "DO" });
    } else if (username == "INKASO") {
      //is.setState({ sDocType: "INV" });
      this.setState({ sDocType: "DO" });
    }
        // window.setTimeout(function () {
        //   alert(this.state.sDocType);
        // }, 10); 
  };

  handleChangeDoctype = (e) => {
    this.setState({ sDocType: e.target.value });
          window.setTimeout(function () {
            document.getElementById("scanfield").focus();
          }, 10); 
  };

  handleInsert = (e) => {

    if (this.state.newScan !== "") {
      this.setState({ sDatainsert: this.state.dataTable });
    let datainsert = this.state.dataTable;
    document.getElementById("scanfield").value = "";

    let dataInv = [];

    // if (this.state.ableSubmit) {

      let {
        dataInvoice,
        dataSupport,
        user,
        documentList,
        supStatus,
        supStatusStr,
      } = this.state;

      supStatus = "Y";
      supStatusStr = "COMPLETE";

      documentList.forEach((item, index) => {
        if (item.complete == "N") {
          supStatus = "N";
          supStatusStr = "INCOMPLETE";
        }
      });

      dataInvoice.map((item, index) => {
        //hanya yang exist yang diinsert
        dataInv.push({
          CUSTOMER_ID: item.CUSTOMER_ID,
          CUSTOMER_NAME: item.CUSTOMER_NAME,
          POPULAR_NAME: item.POPULAR_NAME_CUSTOMER,
          CUSTOMER_TRX_ID: item.CUSTOMER_TRX_ID,
          TRX_NUMBER: item.TRX_NUMBER,
          TTF_NO: item.TTF_NO == "x" ? "" : item.TTF_NO,
          AMOUNT: item.AMOUNT,
          TRX_DATE: item.TRX_DATE,
          DUE_DATE: item.DUE_DATE,
          PO_NUMBER: item.PO_NUMBER,
          FAKTUR_PAJAK: item.FAKTUR_PAJAK,
          AMOUNT_REMAINING: item.AMOUNT_REMAINING,
        });
      });

      let param = {
        //   awb_date: sAwbDate != "" ? moment(sAwbDate).format("YYYY-MM-DD") : "",
        dataInvoice: dataInv,
        dataSupport: documentList,
        docType: this.state.sDocType,
        username: this.state.user.username,
        orgid: this.state.user.org_id,
        orgname: this.state.user.org_name,
        rolename: this.state.user.role_name,
        method: this.state.sDocType,
        supportStatus: supStatus,
      };

      // console.log(param);

      this.setState({ loading: true });
      let url = "/api/collect/v1/trxmonitoring/submit-trx";
      request.postCollect(url, param, {
        success: function (response) {
          let { message, data } = response.data;
          window.scrollTo(0, 0);
          this.setState({
            loading: false,
            success: message,
            error: [],
            // submitted_stat: true,
          });
          window.setTimeout(() => {
            this.setState({ loading: false, supStatus, supStatusStr });
          }, 2000);

          // this.state.dataInvoice.map((item, index) => {
            dataInvoice.map((item, index) => {
            //hanya yang exist yang diinsert
            datainsert.push({
              CUSTOMER_ID: item.CUSTOMER_ID,
              CUSTOMER_NAME: item.CUSTOMER_NAME,
              POPULAR_NAME: item.POPULAR_NAME_CUSTOMER,
              CUSTOMER_TRX_ID: item.CUSTOMER_TRX_ID,
              TRX_NUMBER: item.TRX_NUMBER,
              TTF_NO: item.TTF_NO == "x" ? "" : item.TTF_NO,
              AMOUNT: item.AMOUNT,
              TRX_DATE: item.TRX_DATE,
              DUE_DATE: item.DUE_DATE,
              PO_NUMBER: item.PO_NUMBER,
              FAKTUR_PAJAK: item.FAKTUR_PAJAK,
              AMOUNT_REMAINING: item.AMOUNT_REMAINING,
              SUPPORT_COMPLETE: supStatusStr,
            });
          });

          this.setState({
            dataTable: datainsert.reverse(),
            ableSubmit: false,
            docs: [],
          });
        }.bind(this),
        error: function (e) {
          console.log(e);
        },
      });
    // } else {
    //   alert("Tidak dapat disubmit.");
    // }

    }


    // if (this.state.newScan.length > 0) {
      console.log(this.state.sCustomerName);
      console.log(this.state.newScan);

      //http://localhost:3000/admin/trxmonitor/scaninv
      // Claim To Oracle
      let url = "/api/collect/v1/trxmonitoring/scan-trx";
      let { sScanResult, sDocType } = this.state;
      let param = {
        datascan: sScanResult,
        branchid: this.state.user.org_id,
        doctype: sDocType,
        rolename: this.state.user.role_name,
      };
      this.setState({ loading: true });
      request.postCollect(url, param, {
        success: function (response) {
          let { data } = response.data;
          let dataInvoice = data.invoice;
          let dataSupport = data.support;

          this.setState({
            dataInvoice,
            dataSupport,
            documentList: [],
          });
          let { documentList } = this.state;

          dataSupport.map((item, index) => {
            documentList.push({
              doc_id: item.doc_id,
              doc_name: item.doc_name,
              jumlah: item.jumlah,
              complete: item.complete,
              a_new: "N",
            });
          });
          this.setState({ documentList: documentList });
            window.setTimeout(() => {
              this.setState({ docs: [] });
            }, 200);

          window.setTimeout(() => {
            this.setState({
              docs: dataSupport,
            });
          }, 200);

          this.state.dataInvoice.map((item, index) => {
            if (item.EXIST == "Y") {
              if (this.cekinvoiceNoExist(item.CUSTOMER_TRX_ID)) {
                this.setState({ ableSubmit: true});
              } else {
                alert("Dokumen Sudah Diinput Sebelum nya");
                this.setState({ ableSubmit: true });
              }
            } else {
              alert(item.EXIST);
              this.setState({ ableSubmit: true });
            }
            this.setState({ exist: item.EXIST });
          });
            this.setState({    
              //dataTable: dataInvoice,
              loading: false,
            });
        }.bind(this),
        error: function (e) {
          alert("Failed to checking data");
          
          this.setState({
            loading: false,
          });
          console.log(e.message);
        },
      });
    // } else {
    //   alert("Please Scan Document..");
    // }
  };

  renderDocument = () => {
    return this.state.docs.map((item, index) => (
      <div className="row">
        <div className="col-md-12" key={index}>
          <div className="col-md-12">
            <div className="form-check">
              <input
                className="form-check-input"
                // disable={item.new == "N" && item.complete == "Y" ? true : false}
                type="checkbox"
                value={item.doc_id}
                defaultChecked={item.complete == "Y" ? true : false}
                onClick={this.handleClickDocument.bind(this)}
                id="defaultCheck1"
              />
              <label className="form-check-label" htmlFor="defaultCheck1">
                {item.doc_name}
              </label>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  renderType = () => {
    let rolename = this.state.user.role_name;
    // console.log(this.state.user);
    if (rolename == "ADM-UMUM" || rolename == "TAX-HO") {
      // console.log(this.state.sDocType);
      return (
        <div>
          <div className="row">
            <div className="col-sm-9 mt-2">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  //   checked = "true"
                  type="radio"
                  name="trxtype"
                  id="inlineRadio1"
                  value="CN"
                  onChange={this.handleChangeDoctype.bind(this)}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  CN
                </label>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (rolename == "ADM-INKASO") {
      return (
        <div>
          <div className="row">
            <div className="col-sm-9 mt-2">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="trxtype"
                  id="inlineRadio1"
                  value="DO"
                  checked = "true"
                  onChange={this.handleChangeDoctype.bind(this)}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  DO
                </label>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (rolename == "INKASO") {
      return (
        <div>
          <div className="row">
            <div className="col-sm-9 mt-2">
              {/* <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="trxtype"
                  id="inlineRadio1"
                  value="INV"
                  checked
                  onChange={this.handleChangeDoctype.bind(this)}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  INV
                </label>
              </div> */}
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="trxtype"
                  id="inlineRadio1"
                  value="DO"
                  onChange={this.handleChangeDoctype.bind(this)}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  DO
                </label>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="row">
            <div className="col-sm-9 mt-2">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="trxtype"
                  id="inlineRadio1"
                  value="DO"
                  onChange={this.handleChangeDoctype.bind(this)}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  DO
                </label>
              </div>
              {/* <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="trxtype"
                  id="inlineRadio1"
                  value="INV"
                  onChange={this.handleChangeDoctype.bind(this)}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  INV
                </label>
              </div> */}
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  //   checked = "true"
                  type="radio"
                  name="trxtype"
                  id="inlineRadio1"
                  value="CN"
                  onChange={this.handleChangeDoctype.bind(this)}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  CN
                </label>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;

    let { documentList } = this.state;
    // this.setState({ documentList: dataSupport });

    let doc_id = "";
    let doc_name = "";
    let jumlah = "";
    let complete = "";
    let a_new = "";

    if (is_checked) {
      //   documentList.push({ doc_id: docId});

      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.doc_id) === parseInt(docId);
      });

      doc_id = documentList[getIndex].doc_id;
      doc_name = documentList[getIndex].doc_name;
      jumlah = documentList[getIndex].jumlah;
      complete = "Y";
      a_new = documentList[getIndex].a_new;

      documentList.splice(getIndex, 1);
      documentList.push({
        doc_id: doc_id,
        doc_name: doc_name,
        jumlah: jumlah,
        complete: "Y",
        a_new: a_new,
      });
    } else {
      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.doc_id) === parseInt(docId);
      });

      doc_id = documentList[getIndex].doc_id;
      doc_name = documentList[getIndex].doc_name;
      jumlah = documentList[getIndex].jumlah;
      complete = "Y";
      a_new = documentList[getIndex].a_new;

      documentList.splice(getIndex, 1);
      documentList.push({
        doc_id: doc_id,
        doc_name: doc_name,
        jumlah: jumlah,
        complete: "N",
        a_new: a_new,
      });
    }

    this.setState({ documentList });

    console.log(this.state.documentList);

        window.setTimeout(function () {
          document.getElementById("scanfield").focus();
        }, 10); 
  };

  cekinvoiceNoExist = (trx_id) => {
    let find = _.find(this.state.dataTable, function (o) {
      return o.CUSTOMER_TRX_ID === trx_id;
    });
    return find ? false : true;
  };

  cekDocIncomplete = () => {
    let find = _.find(this.state.documentList, function (o) {
      return o.complete == "N";
    });
    return find ? true : false;
  };

  onSelectCustomer = (suggestions, index) => {
    this.state.sCustomerId = suggestions.value ? suggestions.value : null;
    this.state.sCustomerName = suggestions.text ? suggestions.text : null;
    this.state.sPopular_name = suggestions.name ? suggestions.name : null;

    console.log(this.state.sPopular_name);
  };

  handleKeyDown = (e) => {
    
    let val = ""
    
    if (
      e.key === "Enter" ||
      e.keyCode === 13 ||
      e.key === "Tab" ||
      e.keyCode === 9
    ) {
      e.preventDefault();
      // this.setState({ docs: [] });
      if (this.validateScan()) {
        if (e.target.value.length > 5) {
          // alert(e.target.value.length);
          val = e.target.value;
          this.state.sScanResult = val;
          console.log(this.state.sScanResult);
          //   document.getElementById("scanfield").value = "";
          document.getElementById("tempfield").value = val;
          document.getElementById("scanfield").value = "";
          
          // alert(val);
          this.handleInsert();
          this.state.newScan = val;
          // this.setState({ newScan: val });
        }
      }
    }
  };

  validateScan = () => {
    // alert("tes");
    this.state.errorscan = 0;
    if (this.state.sDocType.length === 0) {
      alert("Pilih dahulu tipe dokumen");
      this.state.errorscan = 1;
    }
    if (this.state.errorscan > 0) {
      document.getElementById("scanfield").value = "";
    }
    return true;
  };

  validateSubmit = () => {
    let error = [];

    if (this.state.sDest == "CAB") {
      if (this.state.sCabangId.length === 0) {
        error.push("Please select Branch");
      }
    }

    if (this.state.sDest == "CUS") {
      if (this.state.sCustomerId.length === 0) {
        error.push("Please select customer");
      }
    }

    if (this.state.newScan.length === 0) {
      error.push("Please scan document");
    }

    if (error.length > 0) {
      document.getElementById("scanfield").value = "";
    }

    if (error.length > 0) {
      this.setState({ error: error });
      window.scrollTo(0, 0);
      console.log(this.state.error);
      return false;
    } else {
      return true;
    }
  };

  renderScan = () => {
    return (
      <div className="row">
        <div className="col-md-6">
          {/* <div className="form-group row">
            <label
              htmlFor="inputEmail3"
              className="col-sm-3 col-form-label"
            ></label>
            <div className="col-sm-9">
              <textarea
                disabled
                id="scanresult"
                cols="120"
                rows="5"
                // onChange={this.handleChangeInput.bind(this)}
                // value={this.state.sScanResult}
              />
            </div>
          </div> */}
        </div>
      </div>
    );
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "Invoice No.",
          accessor: "TRX_NUMBER",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),

          //   width: 150,
          Cell: (row) => (
            <div style={{ textAlign: "center" }}>
              <span>{row.value}</span>
            </div>
          ),
        },
        {
          Header: "Customer Name",
          accessor: "CUSTOMER_NAME",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),

          //   width: 150,
          Cell: (row) => (
            <div style={{ textAlign: "left" }}>
              <span>{row.value}</span>
            </div>
          ),
        },

        {
          Header: "Original Amount",
          accessor: "AMOUNT",
          className: "text-right",
          // filterable: true,
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },

        {
          Header: "Outstanding Amount",
          accessor: "AMOUNT_REMAINING",
          className: "text-right",
          // filterable: true,
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },

        {
          Header: "Supporting Doc.",
          accessor: "SUPPORT_COMPLETE",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),

          //   width: 150,
          Cell: (row) => (
            <div style={{ textAlign: "left" }}>
              <span>{row.value}</span>

              {/* <span>{this.state.supStatusStr}</span> */}
            </div>
          ),
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  deleteLine = (id) => {
    let datatemp = this.state.dataTable;

    if (window.confirm("Are you sure to delete this line?")) {
      // alert("ok");
      let getIndex = _.findIndex(datatemp, function (o) {
        return parseInt(o.CUSTOMER_TRX_ID) === parseInt(id);
      });
      datatemp.splice(getIndex, 1);
    }

    this.setState({ dataTable: datatemp });
    console.log(this.state.dataTable);
    //
  };

  handleCancel = () => {
    window.location.reload();
  };

  handleSubmit = (e) => {
    this.setState({ sDatainsert: this.state.dataTable });
    let datainsert = this.state.dataTable;
    console.log(datainsert);
    console.log("before");

    document.getElementById("scanfield").value = "";

    let dataInv = [];

    // if (this.state.ableSubmit) {
      //   let dataInvoice = this.state.dataInvoice;
      //   let dataSupport = this.state.dataSupport;
      //   let user = this.state.user;

      let {
        dataInvoice,
        dataSupport,
        user,
        documentList,
        supStatus,
        supStatusStr,
      } = this.state;

      //   if (this.cekDocIncomplete == true ){
      //       this.setState({ supStatus: "N", supStatusStr: "NOT COMPLETE" });
      //   }
      //   else
      //   {
      //       this.setState({ supStatus: "Y", supStatusStr: "COMPLETE" });
      //   }

      supStatus = "Y";
      supStatusStr = "COMPLETE";

      documentList.forEach((item, index) => {
        if (item.complete == "N") {
          supStatus = "N";
          supStatusStr = "INCOMPLETE";
        }
      });

      dataInvoice.map((item, index) => {
        //hanya yang exist yang diinsert
        dataInv.push({
          CUSTOMER_ID: item.CUSTOMER_ID,
          CUSTOMER_NAME: item.CUSTOMER_NAME,
          POPULAR_NAME: item.POPULAR_NAME_CUSTOMER,
          CUSTOMER_TRX_ID: item.CUSTOMER_TRX_ID,
          TRX_NUMBER: item.TRX_NUMBER,
          TTF_NO: item.TTF_NO == "x" ? "" : item.TTF_NO,
          AMOUNT: item.AMOUNT,
          TRX_DATE: item.TRX_DATE,
          DUE_DATE: item.DUE_DATE,
          PO_NUMBER: item.PO_NUMBER,
          FAKTUR_PAJAK: item.FAKTUR_PAJAK,
          AMOUNT_REMAINING: item.AMOUNT_REMAINING,
        });
      });


      let param = {
        //   awb_date: sAwbDate != "" ? moment(sAwbDate).format("YYYY-MM-DD") : "",
        dataInvoice: dataInv,
        dataSupport: documentList,
        docType: this.state.sDocType,
        username: this.state.user.username,
        orgid: this.state.user.org_id,
        orgname: this.state.user.org_name,
        rolename: this.state.user.role_name,
        method: this.state.sDocType,
        supportStatus: supStatus,
      };

      console.log(param);

      this.setState({ loading: true });
      let url = "/api/collect/v1/trxmonitoring/submit-trx";
      request.postCollect(url, param, {
        success: function (response) {
          let { message, data } = response.data;
          window.scrollTo(0, 0);
          this.setState({
            loading: false,
            success: message,
            error: [],
            // submitted_stat: true,
          });
          window.setTimeout(() => {
            // window.location.reload();
            // this.createPdf.bind(this);
            // window.open(this.state.filePATH, "_blank");
            this.setState({ loading: false, supStatus, supStatusStr });
          }, 2000);

          this.state.dataInvoice.map((item, index) => {
            //hanya yang exist yang diinsert
            datainsert.push({
              CUSTOMER_ID: item.CUSTOMER_ID,
              CUSTOMER_NAME: item.CUSTOMER_NAME,
              POPULAR_NAME: item.POPULAR_NAME_CUSTOMER,
              CUSTOMER_TRX_ID: item.CUSTOMER_TRX_ID,
              TRX_NUMBER: item.TRX_NUMBER,
              TTF_NO: item.TTF_NO == "x" ? "" : item.TTF_NO,
              AMOUNT: item.AMOUNT,
              TRX_DATE: item.TRX_DATE,
              DUE_DATE: item.DUE_DATE,
              PO_NUMBER: item.PO_NUMBER,
              FAKTUR_PAJAK: item.FAKTUR_PAJAK,
              AMOUNT_REMAINING: item.AMOUNT_REMAINING,
              SUPPORT_COMPLETE: supStatusStr,
            });
          });

          this.setState({
            dataTable: datainsert.reverse(),
            ableSubmit: false,
            // docs: [],
          });
        }.bind(this),
        error: function (e) {
          console.log(e);
        },
      });
    // } else {
    //   alert("Tidak dapat disubmit.");
    // }
  };

  renderButton = () => {
    return (
      <div className="col-md-9 mt-2">
        <div className="col-sm-8 mt-2">
          <button
            disabled={this.state.ableSubmit == false ? true : false}
            type="button"
            className="btn btn-success"
            style={{ height: "50px", width: "150px" }}
            // onClick={this.createPdf.bind(this)}
            onClick={this.handleSubmit.bind(this)}
          >
            Finish
          </button>
        </div>
      </div>
    );
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fas fa-check"></i> {this.state.success}
        </div>
      );
    }
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showSuccess()}
                    {this.showError()}
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-4">
                          <h6>Scan</h6>
                          <div className="form-group row">
                            {/* <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Invoice No.
                            </label> */}
                            <div className="col-sm-9 mt-2">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="scanfield"
                                name="ref_number"
                                placeholder="Place your cursor here for scan"
                                // onChange={this.handleChangeInputScan.bind(this)}
                                onKeyDown={this.handleKeyDown.bind(this)}
                                // value={this.state.ref_number}
                              />
                            </div>

                            <div className="col-sm-9 mt-2">
                              {/* <h6>Type</h6>{""} */}
                              {/* <div className="form-group row"> */}
                                {this.renderType()}
                              {/* </div> */}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <h6>Supporting Document</h6>
                          <div className="form-group row">
                            {/* <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Invoice No.
                            </label> */}
                            <div className="col-sm-9 mt-2">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="tempfield"
                                name="temp_number"
                                placeholder=""
                                disabled
                                // onChange={this.handleChangeInputScan.bind(this)}
                                // onKeyDown={this.handleKeyDown.bind(this)}
                                // value={this.state.ref_number}
                              />
                            </div>
                          </div>
                          <div className="row"> {this.renderDocument()}</div>
                          {/* <div className="row">{this.renderButton()}</div> */}
                        </div>
                        <div className="col-sm-2">
                          <h6> </h6>
                          <div className="row">{this.renderButton()}</div>
                        </div>

                        {/* {this.renderScan()} */}
                      </div>
                      {/* <h6>Supporting Document</h6>
                      <div className="row">
                        <div className="col-md-6">{this.renderDocument()}</div>
                      </div>
                      <div className="row">{this.renderButton()}</div> */}
                      <hr />
                      &nbsp;
                      {this.renderTable()}
                      <hr />
                      <div className="form-group row">
                        {/* {this.renderButton()} */}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default SendDocument;
